import map from 'lodash/map'

export const parseTestPeriod = testPeriod => {
  const testPeriodAsArray = map(testPeriod.periodo_teste, ({ id, value }) => ({
    key: id,
    text: value,
  }))
  return testPeriodAsArray
}
